import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { getSelectorElementFromElement } from '@opten/dom/get-selector-element-from-element';
import { hasClass } from '@opten/dom/has-class';
import { removeClass } from '@opten/dom/remove-class';
import { EventDispatcher } from '@opten/events/event-dispatcher';

import { MapStyles } from './map';
import { MapSearcher } from './map-searcher';

@Component({ className: 'js-sidebar' })
export class SidebarComponent {
	static onPageChange = new EventDispatcher<HTMLElement>();

	private triggers: HTMLElement[] = [];
	private closers: HTMLElement[] = [];

	private mapSearcher: MapSearcher;

	constructor(private element: HTMLElement) {
		this.triggers = Array.from(
			this.element.getElementsByClassName('js-sidebar-item')
		) as HTMLElement[];
		this.closers = Array.from(
			this.element.getElementsByClassName('js-sidebar-close')
		) as HTMLElement[];

		this.triggers.forEach((trigger) => {
			const target = getSelectorElementFromElement(trigger);
			const segment = trigger.getAttribute('href');
			if (window.location.href.indexOf(segment) >= 0) {
				this.open(trigger, target, true);
			}
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				const isActive = hasClass(trigger, 'is-active');
				this.triggers.filter((o) => removeClass(o, 'is-active'));
				if (isActive) {
					this.close();
				} else {
					this.open(trigger, target);
				}
			});
			const otherTriggers = Array.from(
				document.querySelectorAll(`[href^='${segment}']`)
			) as HTMLLinkElement[];
			if (otherTriggers && otherTriggers.length > 0) {
				otherTriggers.forEach((otherTrigger) => {
					if (otherTrigger != trigger) {
						otherTrigger.addEventListener('click', (e) => {
							e.preventDefault();
							addClass(trigger, 'is-active');
							this.open(
								otherTrigger,
								target,
								false,
								otherTrigger.getAttribute('href')
							);
						});
					}
				});
			}
		});

		document.addEventListener('click', (e) => {
			if (
				this.triggers.some((o) => hasClass(o, 'is-active')) &&
				document.body.contains(e.target) &&
				!e.target.closest('.js-sidebar') &&
				hasClass(document.body, 'has-overlay') == false
			) {
				e.preventDefault();
				this.close();
			}
		});

		this.closers.forEach((closer) => {
			closer.addEventListener('click', (e) => {
				e.preventDefault();
				this.close();
			});
		});
	}

	// tslint:disable-next-line: max-func-body-length
	private open(
		trigger,
		target,
		ignoreHistory = false,
		segmentAndFilter = undefined
	) {
		addClass(trigger, 'is-active');
		if (ignoreHistory === false) {
			const segment = trigger.getAttribute('href');
			const filterActive = target.getAttribute('data-filter-active');
			if (segmentAndFilter) {
				history.replaceState(null, null, segmentAndFilter);
			} else if (filterActive) {
				history.replaceState(null, null, `${segment}/${filterActive}`);
			} else {
				history.replaceState(null, null, segment);
			}
		}
		if (hasClass(target, 'js-map-filter')) {
			addClass(document.body, 'has-overlay');
			if (!this.mapSearcher) {
				const render = target.querySelector(
					'.js-sidebar-render'
				) as HTMLElement;
				fetch(render.getAttribute('data-url'), {
					method: 'get',
					cache: 'default',
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'accept-language': document.documentElement.lang,
						'X-Requested-With': 'XMLHttpRequest',
					},
				})
					.then((response) => response.text())
					.then((response) => {
						render.innerHTML = response;
						removeClass(render, 'is-loading');
						SidebarComponent.onPageChange.dispatch(
							render.children[0]
						);
						this.mapSearcher = new MapSearcher(target, target, {
							mapStyles: MapStyles,
						});
					})
					.catch((error) => {
						render.innerHTML =
							'Map could not be loaded. Please reload page.';
					});
			} else {
				this.mapSearcher.reInit();
			}
		}
	}

	private close() {
		removeClass(document.body, 'has-overlay');
		this.triggers.filter((o) => {
			removeClass(o, 'is-active');
		});
		history.replaceState(
			null,
			null,
			window.location.href.replace(window.location.hash, '')
		);
	}
}
